import { cn } from '@/lib/utils';
import { BarChart3, LineChart } from 'lucide-react';

interface ChartInfo {
    elementId: string;
    title: string;
    chartType?: string;
}

interface DMInteractiveChartProps {
    charts: ChartInfo[];
}

const DMInteractiveChart = ({ charts }: DMInteractiveChartProps) => {
    if (!charts.length) return null;

    const handleClick = () => {
        // Open sidebar and highlight all associated charts
        window.dispatchEvent(
            new CustomEvent('openChartsSidebar', {
                detail: { elementIds: charts.map((c) => c.elementId) }
            })
        );
    };

    const hasLine = charts.some((c) => c.chartType === 'line');
    const Icon = hasLine ? LineChart : BarChart3;

    const title =
        charts.length === 1
            ? charts[0].title
            : `${charts.length} Interactive Charts`;

    const subtitle =
        charts.length === 1
            ? 'Interactive Chart'
            : charts.map((c) => c.title).join(', ');

    return (
        <button
            onClick={handleClick}
            className={cn(
                'relative flex items-center w-full overflow-clip',
                'bg-background border border-border rounded-lg p-4',
                'hover:bg-muted/20 transition-colors cursor-pointer',
                'text-left group'
            )}
        >
            <div className="flex flex-col grow min-w-0">
                <span className="font-medium text-foreground text-base truncate leading-6">
                    {title}
                </span>
                <span className="max-w-[60%] text-muted-foreground text-sm truncate leading-5">
                    {subtitle}
                </span>
            </div>
            <div
                className={cn(
                    'top-4 right-16 absolute flex justify-center items-center',
                    'bg-background border border-foreground/20 dark:border-border rounded-lg p-4 pb-16',
                    'rotate-11 transition-transform duration-200 ease-linear',
                    'group-hover:rotate-6',
                    'group-hover:scale-105'
                )}
            >
                <Icon className="w-6 h-6 text-muted-foreground" />
            </div>
        </button>
    );
};

export default DMInteractiveChart;
